import React from 'react'
import IMG_ICON_BASES_CONCURSO from '../../../assets/img/icon02-bases-concurso.svg'
import IMG_ICON_BUENAS_PRACTICAS from '../../../assets/img/icon02-buenas-practicas.svg'
import IMG_ICON_PREGUNTAS_FRECUENTES from '../../../assets/img/icon03-preguntas-frecuentes.svg'
import IMG_ICON_CONTACTO from '../../../assets/img/icon02-contacto.svg'
import { useNavigate } from 'react-router-dom'

export default function Main() {

    const navigateTo = useNavigate()

    const btnBasesOnClick = () => {
        navigateTo('/competition-rules')
    }

    const btnBuenasPracticasOnClick = () => {
        navigateTo('/good-practices')
    }

    const btnFaqOnClick = () => {
        navigateTo('/faq')
    }

    const btnContactoOnClick = () => {
        navigateTo('/contact-us')
    }

    const btnIngresarOnClick = () => {
        alert('TODO: deriva a otro subproyecto')
    }

    const currentYear = new Date().getFullYear() % 100

    return (
        <>
            <main className="theme-light">
                <div className="banner banner-primary rounded-0">
                    <div className="container position-relative">
                        <div className="container py-5">
                            <div className="row">
                                <div className="col-lg-7 col-12 pt-lg-5 px-lg-0 px-5 d-flex flex-column" id="headerContent">
                                    <h1 className="fw-light text-white mx-auto">
                                        Bienvenido al<br />
                                        <span className="fw-medium">Concurso Compartiendo Buenas Prácticas en Seguridad y Salud en el Trabajo</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div className="txt-year2 position-absolute end-0">
                            20<br /><span>{currentYear}</span>
                        </div>
                    </div>
                </div>
                <div className="container py-5">
                    <div className="row pt-5">
                        <div className="col-md-6 pb-5">
                            <h1 className="h2 fw-bold mb-5">Preguntas Frecuentes</h1>

                            <h3 className="h5 fw-bold">¿Cómo postular?</h3>
                            <p>Para postular, cada empresa deberá llenar el formulario que se encontrará disponible en la página web http://www.buenaspracticasensst.cl adjuntando todos los antecedentes y documentos que sirvan de respaldo y fundamenten el mérito de la buena práctica presentada.</p>
                            <hr className="my-4" />
                            <h3 className="h5 fw-bold">¿Cuáles son los roles de usuario disponibles al crear una cuenta en el formulario de registro?</h3>
                            <p>Durante el proceso de generación de una cuenta nueva a través del formulario de registro, el sistema procederá a crear un registro de Empresa, siendo el primer usuario asignado a esta cuenta el rol de "Administrador".</p>
                            <p>El rol de "Administrador" otorga la capacidad de gestionar los usuarios dentro de la empresa, permitiendo la creación, edición y eliminación de los mismos. Además, se le brinda la habilidad de crear, editar y enviar postulaciones relacionadas a las buenas prácticas.</p>
                            <p>Por otro lado, el rol de "Agente" habilita la posibilidad de crear, editar y enviar postulaciones relacionadas a las buenas prácticas, sin tener la capacidad de administrar usuarios dentro de la plataforma.</p>
                            <hr className="my-4" />
                            <h3 className="h5 fw-bold">¿Puedo postular más de una práctica?</h3>
                            <p>Sí, puedes postular más de una práctica, sin embargo, la empresa postulante no podrá presentar buenas prácticas duplicadas, entendiéndose como tales, aquellas que habiéndose implementado en diferentes centros de trabajo/área interna/división de la empresa, correspondan al mismo problema a resolver y su respectiva solución. Para efectos del concurso, se considerará a la empresa postulante como responsable de centralizar la información de sus buenas prácticas. En el caso de presentarse duplicidad, la CChC y Mutual se reservan el derecho a dejar fuera de bases y eliminar una de las buenas prácticas duplicadas, quedando a criterio de dichas instituciones la selección de la buena práctica que continuará en el concurso.</p>
                            <hr className="my-4" />
                            <h3 className="h5 fw-bold">¿Puedo postular con distintas obras, faenas y/o centros de trabajo?</h3>
                            <p>Sí, puedes postular buenas prácticas implementadas en distintos centros de trabajo, faenas u obras. Se recomienda realizar concursos internos que permitan la postulación de prácticas obtenidas de dicha instancia.</p>
                            <hr className="my-4" />
                            <h3 className="h5 fw-bold">Si mi Buena Práctica no ganó en versiones anteriores, ¿la puedo volver a postular?</h3>
                            <p>Sí, sin embargo, se recomienda la revisión y/o mejora de la postulación y los antecedentes presentados, todas vez que las prácticas son revisadas una a una por un equipo técnico especialista, y serán descartadas en el caso de que se presenten postulaciones exactamente iguales a las de versiones anteriores.</p>
                        </div>
                        <div className="col-md-6 me-0">
                            <div className="row row-cols-2 g-4 text-center mt-2 nav-icons">
                                <div className="col">
                                    <a onClick={
                                        btnBasesOnClick
                                    } className="p-3 d-block react-link">
                                        <img src={
                                            IMG_ICON_BASES_CONCURSO
                                        } className="img-fluid" />

                                    </a>
                                    <span className="small fw-bold lh-1 text-wrap" style={
                                        { width: '6rem' }
                                    }>Bases del <br />Concurso</span>
                                </div>
                                <div className="col">
                                    <a onClick={
                                        btnBuenasPracticasOnClick
                                    } className="p-3 d-block react-link">
                                        <img src={
                                            IMG_ICON_BUENAS_PRACTICAS
                                        } className="img-fluid" />

                                    </a>
                                    <span className="small fw-bold lh-1 text-wrap" style={
                                        { width: '6rem' }
                                    }>Buenas <br />Prácticas</span>
                                </div>
                                <div className="col page-active">
                                    <a onClick={
                                        btnFaqOnClick
                                    } className="p-3 d-block react-link">
                                        <img src={
                                            IMG_ICON_PREGUNTAS_FRECUENTES
                                        } className="img-fluid" />

                                    </a>
                                    <span className="small fw-bold lh-1 text-wrap" style={
                                        { width: '6rem' }
                                    }>Preguntas <br />Frecuentes</span>
                                </div>
                                <div className="col">
                                    <a onClick={
                                        btnContactoOnClick
                                    } className="p-3 d-block react-link">
                                        <img src={
                                            IMG_ICON_CONTACTO
                                        } className="img-fluid" />

                                    </a>
                                    <span className="small fw-bold lh-1">Contacto</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </>
    )
}
